import { useContext } from "react";

import { useMutation, useQueryClient } from "@tanstack/react-query";

import { scheduleCrud } from "@/api/schedule";
import { Button } from "@/components/common/Button";
import { ModalAlert } from "@/components/common/modals";
import { useDepartmentRoute } from "@/hooks/common/use-department-route";
import { useModal } from "@/hooks/common/use-modal";
import { showToast } from "@/providers";
import { useUserStore } from "@/stores/use-user-store";
import { canResumeSchedule } from "@/utils/features/schedule/permission";
import { getUserRoleByDepartment } from "@/utils/user-positions";

import { ScheduleActionsContext } from "../Provider";

export const ScheduleActionsResume = () => {
  const { schedule } = useContext(ScheduleActionsContext);
  const { department } = useDepartmentRoute();
  const activeUser = useUserStore((state) => state.activeUser);
  const modal = useModal();
  const queryClient = useQueryClient();
  const activeRole = getUserRoleByDepartment(activeUser, department);

  const mutation = useMutation({
    mutationFn: () => scheduleCrud.resume(schedule.id),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["schedule"], refetchType: "all" });
      modal.closeModal();
      showToast({ type: "success", title: "Atendimento reaberto com sucesso!" });
    },
    onError: () =>
      showToast({
        type: "error",
        title: "Erro ao reabrir atendimento",
        content: "Tente novamente em alguns instantes.",
      }),
  });

  if (!canResumeSchedule(activeRole, schedule)) {
    return null;
  }

  return (
    <>
      <Button variant="secondary" onClick={modal.openModal} full>
        Reabrir atendimento
      </Button>
      <ModalAlert
        isOpen={modal.isModalOpen}
        onClose={mutation.isPending ? undefined : modal.closeModal}
        isOverlayCloseable={!mutation.isPending}
        cancelable
        title="Tem certeza que deseja reabrir o atendimento do talento?"
        description="Ao confirmar, o talento terá seu agendamento reaberto para Em atendimento."
        actions={[
          {
            type: "submit",
            children: "Sim, reabrir atendimento",
            variant: "primary",
            className: "whitespace-nowrap",
            isLoading: mutation.isPending,
            onClick: () => mutation.mutate(),
          },
        ]}
      />
    </>
  );
};
